import React from 'react';
import SiteWrapper from "../../SiteWrapper.react";
import AlertasCctvComponente from './AlertasCctvComponente.react';

const url = new URL(window.location.href);
const disp= url.searchParams.get("dispositivo");
const token= url.searchParams.get("token");


const AlertasCctvPage = () => {
  return (
    <>
      {token && disp ?
        <AlertasCctvComponente url={url} token={token} disp={disp} />
        :
        <SiteWrapper>
          <AlertasCctvComponente url={url} token={token} disp={disp} />
        </SiteWrapper>
      }
    </>
    
  );
}


export default AlertasCctvPage;
